/**
 * Returns data attributes to suppress password manager hints (1Password, LastPass)
 * when `autoComplete` is set to `"off"`.
 */
export function getPasswordManagerProps(autoComplete: string | undefined) {
  if (autoComplete === 'off') {
    return { 'data-1p-ignore': true, 'data-lpignore': true } as const;
  }
  return {};
}
